// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Wix_Madefor_Display_40add2'","fontStyle":"normal"},"className":"__className_40add2","variable":"__variable_40add2"};